<template>
    <mdb-container>
        <Vedheader></Vedheader>
        <section class="mt-3">
            <mdb-alert color="danger" v-if="error" class="mt-3">
                {{ error }}
            </mdb-alert>
            <mdb-row v-if="!isLoading && !showExamResults">
                <mdb-col md="12" class="mb-3">
                    <mdb-card >
                        <mdb-card-header cascade class="text-center">
                            <h5 class="mb-0 font-weight-bold">Examen final</h5>
                        </mdb-card-header>
                        <mdb-card-body cascade>
                            <h4>Question #{{this.currentQuestion+1}} sur {{questions.length}}</h4>
                            <h5>{{questions[currentQuestion].question}}</h5>
                            <mdb-input v-for="answer in questions[currentQuestion].answer" v-bind:id="answer.id" name="theanswer" type="radio" v-model="answers[currentQuestion]" :key="answer.id" v-bind:radioValue="answer.id" v-bind:label="answer.content" />
                            <mdb-container class="mt-3">
                                <mdb-btn v-if="currentQuestion>0"  v-on:click="prevQuestion()">Question précédente</mdb-btn>
                                <mdb-btn class="float-right" v-if="currentQuestion<questions.length-1" v-on:click="nextQuestion()">Question suivante</mdb-btn>
                            </mdb-container>
                            <mdb-container class="mt-3 text-center" v-if="currentQuestion===questions.length-1">
                                <mdb-btn size="lg" color="primary" v-on:click="checkAnswers">Passer aux résultats de l’examen</mdb-btn>
                            </mdb-container>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <mdb-row v-if="showExamResults">
                <mdb-col md="12" class="mb-3">
                    <mdb-card >
                        <mdb-card-header cascade class="text-center">
                            <h5 class="mb-0 font-weight-bold">Résultats de l'examen</h5>
                        </mdb-card-header>
                        <mdb-card-body cascade v-if="exampassed">
                            <h4>Félicitation!</h4>
                            <h5>Vous avez obtenu la note de passage minimum exigée pour cet examen.</h5>
                            <p>En effet, vous avez répondu correctement à {{nbgoodanswer}} réponses.</p>
                            <mdb-btn size="lg" color="default" :href="diplomelink" target="_blank" tag="a">Obtenir mon diplôme</mdb-btn>
                        </mdb-card-body>
                        <mdb-card-body cascade v-else>
                            <h4>Vous n’avez pas obtenu la note de passage minimum exigée pour cet examen.</h4>
                            <p>Vous avez obtenu {{nbgoodanswer}} bonnes réponses lors de votre examen</p>
                            <p>Un minimum de {{nbgoodanswertopass}} bonnes réponses est requis pour obtenir votre diplôme</p>
                            <mdb-btn v-on:click="restartexam">Recommencer l'examen</mdb-btn>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
        </section>

        <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
            <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                    &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
                </mdb-container>
            </div>
        </mdb-footer>

    </mdb-container>
</template>

<script>
    import Vedheader from '@/components/Header.vue';
    import {
        mdbContainer,
        mdbAlert,
        mdbCard,
        mdbRow,
        mdbCol,
        mdbCardHeader,
        mdbCardBody,
        mdbFooter,
        mdbInput,
        mdbBtn,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';
    import config from '../libs/config';

    export default {
        name: 'Home',
        components: {
            Vedheader,
            mdbContainer,
            mdbAlert,
            mdbCard,
            mdbRow,
            mdbCol,
            mdbCardHeader,
            mdbCardBody,
            mdbFooter,
            mdbInput,
            mdbBtn,
        },
        data() {
            return {
                isLoading: false,
                error: '',
                questions: [{ question: '', answer: [] }],
                currentQuestion: 0,
                answers: [],
                showExamResults: false,
                exampassed: true,
                nbgoodanswer: 0,
                nbgoodanswertopass: 0,
                diplomelink: '',
            };
        },
        mounted() {
            this.getExamDataAndStart();
            const domain = config.basedomain;
            this.diplomelink = `${domain}download/diplome/${this.$store.state.bearer}.jpg`;
        },
        methods: {
            getExamDataAndStart() {
                const api = new Apicall();
                const self = this;
                api.getExamQuestions().then((response) => {
                    self.questions = response.questions;
                    self.isLoading = false;
                });
            },
            prevQuestion() {
                this.currentQuestion -= 1;
            },
            nextQuestion() {
                this.currentQuestion += 1;
            },
            checkAnswers() {
                const api = new Apicall();
                const self = this;
                api.checkExamAnswers(this.answers).then((response) => {
                    if (response.status === 'OK') {
                        self.showExamResults = true;
                        self.exampassed = response.results.passed;
                        self.nbgoodanswer = response.results.nbgoodanswer;
                        self.nbgoodanswertopass = response.results.nbgoodanswertopass;
                    } else {
                        self.error = response.msg;
                    }
                });
            },
            restartexam() {
                this.currentQuestion = 0;
                this.answers = [];
                this.showExamResults = false;
            },
            downloadiplome() {
                alert('download diplome');
            },
        },
    };
</script>
